import MapView from '@arcgis/core/views/MapView';
import GraphicsLayer from '@arcgis/core/layers/GraphicsLayer';
import { Tool, ToolSlot } from '../framework/Tool';
import { SurfaceDef } from '../model/SurfaceDef';
import { MoveBreaklineInputTask } from './MoveBreaklineInputTask';
import { onCancelBreaklineOperation, onExecuteBreaklineOperation } from '../utils/ToolUtils';

export class MoveBreaklineTool extends Tool {
    private readonly mapView: MapView;
    private readonly surfaceDef: SurfaceDef;
    private readonly breaklinesLayer: GraphicsLayer;
    private task: MoveBreaklineInputTask;

    constructor(mapView: MapView, surfaceDef: SurfaceDef, toolSlot: ToolSlot, breaklinesLayer: GraphicsLayer) {
        super('Move Breakline Vertex', 'single', toolSlot);
        this.mapView = mapView;
        this.surfaceDef = surfaceDef;
        this.breaklinesLayer = breaklinesLayer;
        this.task = new MoveBreaklineInputTask(mapView, surfaceDef);
    }
    protected async onExecuteOperation(): Promise<void> {
        await onExecuteBreaklineOperation(this.task, this.breaklinesLayer, this.surfaceDef.breaklinesSyncSet, this.mapView.spatialReference);
    }

    protected async onCancelOperation(): Promise<void> {
        await onCancelBreaklineOperation(this.task);
    }
}
